// Stage 97: WARP / ZERO visualization — internal type definitions.
//
// Re-exports the canonical bite types from frontend/src/api/gadfly so
// the cross-module air gap (duplication-as-air-gap, established by
// Memory / Homunculus / Phantom / Gadfly) is preserved. The widget
// tree must never import from worker/src or any other host module
// besides hooks/useGadflyTurn and api/gadfly.

import type { Bite, SwatEntry } from '../../api/gadfly';

export type { Bite, BiteKind, SwatEntry, SwatTag } from '../../api/gadfly';

export type WarpMode = 'off' | 'partner' | 'substitute';

export type WarpThemeChannel =
  | 'teal'
  | 'magenta'
  | 'orange'
  | 'lime'
  | 'purple'
  | 'gold'
  | 'crimson'
  | 'cyan';

export const WARP_CHANNELS: readonly WarpThemeChannel[] = [
  'teal',
  'magenta',
  'orange',
  'lime',
  'purple',
  'gold',
  'crimson',
  'cyan',
] as const;

export const WARP_MODES: readonly WarpMode[] = [
  'off',
  'partner',
  'substitute',
] as const;

// The shape BiteWidget / WarpScene consume internally. Identical to the
// host's GadflyTurnState except:
//   (a) swatEntries[] is collapsed into a keyed map for O(1) lookup,
//   (b) `stripeRatioApplied` is renamed `stripeRatio`,
//   (c) turnEnded is required (host added the field in Stage 97).
export interface WarpTurnState {
  turnId: string | null;
  bites: Bite[];
  swats: Record<number, SwatEntry>;
  failed: boolean;
  failureReason: string | null;
  durationMs: number | null;
  modelUsed: string | null;
  stripeRatio: { keep: number; cut: number } | null;
  generatedAt: string | null;
  turnEnded: boolean;
}

export const EMPTY_WARP_TURN: WarpTurnState = {
  turnId: null,
  bites: [],
  swats: {},
  failed: false,
  failureReason: null,
  durationMs: null,
  modelUsed: null,
  stripeRatio: null,
  generatedAt: null,
  turnEnded: false,
};
